import script from "./V5075RedisSwitchPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./V5075RedisSwitchPanel.vue?vue&type=script&setup=true&lang=js"

import "./V5075RedisSwitchPanel.vue?vue&type=style&index=0&id=653a3aab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-653a3aab"]])

export default __exports__